import React from 'react';
import PropTypes from 'prop-types';

import TaggedUrlLine from './TaggedUrlLine.jsx';

// The header and URL lines shared by the in-page section and the drawer panel.
// `children` lands at the end of the header (the drawer's × button).
export default function PreviewContent({
  count, lines, total, limit, showAll, onToggleAll, children = null,
}) {
  return (
    <>
      <div className="tagged-url-preview__header">
        <strong className="tagged-url-preview__title">Preview</strong>
        <span className="tagged-url-preview__summary">{`${count} URL${count === 1 ? '' : 's'}`}</span>
        <span className="tagged-url-preview__notice">Approximate preview</span>
        {children}
      </div>
      <div className={`tagged-url-preview__body${showAll ? ' tagged-url-preview__body--all' : ''}`}>
        {lines.map((segments, index) => (
          <TaggedUrlLine key={index} segments={segments} />
        ))}
        {total > limit && (
          <button type="button" className="btn btn-link btn-xs tagged-url-preview__more" onClick={onToggleAll}>
            {showAll ? 'Show less' : `View all ${total} URLs`}
          </button>
        )}
      </div>
    </>
  );
}

PreviewContent.propTypes = {
  count: PropTypes.number.isRequired,
  lines: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.object)).isRequired,
  total: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  showAll: PropTypes.bool.isRequired,
  onToggleAll: PropTypes.func.isRequired,
  children: PropTypes.node,
};
